const ReunionCartera = () =>
  import("@/views/reunionCartera/ReunionCartera");

export const ReunionCarteraRoute = {
  path: "/reunionCartera",
  component: ReunionCartera,
  meta: {
    requiresAuth: true,
    title: "message.reunionCartera",
    scope: ["aps_broker", "aps_executive"],
    breadcrumb: [
      {
        text: "Reunión con Cartera",
        disabled: false,
        href: "#"
      }
    ]
  }
};
